import React, { useMemo, useState } from 'react'
import { Card, Chip } from '@heroui/react'
import { useStationStore } from '../store/stationStore'
import { Station } from '../types/station'

// ʹ�� Unicode ת���Ա����ļ���������
const KEYWORDS = {
  PREFIX: '\u7535\u5b50\u79d1\u5927\u6e05\u6c34\u6cb3\u6821\u533a', // ���ӿƴ���ˮ��У��
  COMMERCIAL_STREET: '\u5546\u4e1a\u8857', // ��ҵ��
  XUEZI: '\u5b66\u5b50\u9910\u5385', // ѧ�Ӳ���
  CHAOYANG: '\u671d\u9633\u9910\u5385', // ��������
  ZIJING: '\u7d2b\u8346\u9910\u5385', // �Ͼ�����
  FURONG: '\u8299\u84c9\u9910\u5385', // ܽ�ز���
  YINHUA: '\u94f6\u6866\u9910\u5385', // �������
  TAOYUAN: '\u6843\u56ed\u9910\u5385', // ��԰����
  ZHONGCHUANG: '\u4f17\u521b\u7a7a\u95f4', // �ڴ��ռ�
  OTHER: '\u5176\u4ed6\u533a\u57df', // ��������
  HAO: '\u53f7', // ��
  STATION: '\u7535\u7ad9', // ��վ
  CHARGING_PILE: '\u5145\u7535\u6869', // ���׮
  SELECT_REGION: '\u8bf7\u9009\u62e9\u5145\u7535\u533a\u57df', // ��ѡ��������
  STATION_COUNT_SUFFIX: '\u4e2a\u7ad9\u70b9', // ��վ��
  FREE: '\u7a7a\u95f2', // ����
  NO_DATA: '\u8be5\u533a\u57df\u6682\u65e0\u6570\u636e', // ��������������
  PLEASE_SELECT: '\u8bf7\u5148\u9009\u62e9\u4e00\u4e2a\u533a\u57df\u67e5\u770b\u5145\u7535\u6869\u72b6\u6001', // ����ѡ��һ������鿴���׮״̬
  REFRESHING: '\u5237\u65b0\u4e2d...', // ˢ����...
  REFRESH_DATA: '\u5237\u65b0\u6570\u636e', // ˢ������
  TITLE: '\u6821\u5185\u5145\u7535\u6869\u67e5\u8be2', // У�ڳ��׮��ѯ
  // ��ҵ��(x-1���׮)
  COMMERCIAL_STREET_A: '\u5546\u4e1a\u8857(x-1\u5145\u7535\u6869)',
  // ��ҵ��(x�ŵ�վ)
  COMMERCIAL_STREET_B: '\u5546\u4e1a\u8857(x\u53f7\u7535\u7ad9)',
}

// ��ȡ�������Ƶĸ�������
const extractRegion = (name: string): string => {
  let cleanName = name.replace(KEYWORDS.PREFIX, '')
  
  // ��ϵA: ��ҵ��x-1���׮
  // ƥ�������ҵ�� + ���� + -1 + ���׮
  // Unicode: \u5546\u4e1a\u8857 (\d+) -1 \u5145\u7535\u6869
  const factionARegex = /\u5546\u4e1a\u8857(\d+)-1\u5145\u7535\u6869/
  const matchA = cleanName.match(factionARegex)
  if (matchA) {
    return KEYWORDS.COMMERCIAL_STREET_A
  }

  // ��ϵB: ��ҵ��x�ŵ�վ
  // ƥ�������ҵ�� + ���� + �� + ��վ
  // Unicode: \u5546\u4e1a\u8857 (\d+) \u53f7 \u7535\u7ad9
  const factionBRegex = /\u5546\u4e1a\u8857(\d+)\u53f7\u7535\u7ad9/
  const matchB = cleanName.match(factionBRegex)
  if (matchB) {
    return KEYWORDS.COMMERCIAL_STREET_B
  }

  // ������֪�Ĵ�����
  if (cleanName.includes(KEYWORDS.XUEZI)) return KEYWORDS.XUEZI
  if (cleanName.includes(KEYWORDS.CHAOYANG)) return KEYWORDS.CHAOYANG
  if (cleanName.includes(KEYWORDS.ZIJING)) return KEYWORDS.ZIJING
  if (cleanName.includes(KEYWORDS.FURONG)) return KEYWORDS.FURONG
  if (cleanName.includes(KEYWORDS.YINHUA)) return KEYWORDS.YINHUA
  if (cleanName.includes(KEYWORDS.TAOYUAN)) return KEYWORDS.TAOYUAN
  if (cleanName.includes(KEYWORDS.ZHONGCHUANG)) return KEYWORDS.ZHONGCHUANG
  
  // �������ҵ�ֵ���������������ϵ��ͳһ������ϵA�������û�������ҵ��(2��վ��)Ҳ������ҵ��(x-1���׮)���棩
  if (cleanName.includes(KEYWORDS.COMMERCIAL_STREET)) return KEYWORDS.COMMERCIAL_STREET_A

  // �����߼���ȥ��ĩβ�����֡��š���վ�����׮��
  let region = cleanName
  region = region.replace(/[0-9\-]+(\u53f7)?(\u7535\u7ad9|\u5145\u7535\u6869)?$/, '')
  region = region.replace(/(\u7535\u7ad9|\u5145\u7535\u6869)$/, '')
  
  return region || KEYWORDS.OTHER
}

// ��ȡվ���ŵĸ�����������������
const getStationNumber = (name: string): number => {
  let cleanName = name.replace(KEYWORDS.PREFIX, '')
  // ƥ������
  const match = cleanName.match(/(\d+)/)
  if (match) {
    return parseInt(match[1], 10)
  }
  return 999
}

export default function SimpleView() {
  const { stations, isLoading, refreshStations } = useStationStore()
  const [selectedRegion, setSelectedRegion] = useState<string>('')

  // �����������򲢷���
  const regionMap = useMemo(() => {
    const map = new Map<string, Station[]>()
    stations.forEach(station => {
      const region = extractRegion(station.stationName)
      if (!map.has(region)) {
        map.set(region, [])
      }
      map.get(region)?.push(station)
    })

    // ��ÿ�������ڵ�վ���������
    // �û�Ҫ�󣺸��԰�xֵ��������
    map.forEach((list) => {
      list.sort((a, b) => {
        const numA = getStationNumber(a.stationName)
        const numB = getStationNumber(b.stationName)
        return numA - numB
      })
    })

    return map
  }, [stations])

  // ��ȡ�����б�����������
  const regions = useMemo(() => {
    const allRegions = Array.from(regionMap.keys())
    
    // �����߼���
    // 1. ��ϵA (COMMERCIAL_STREET_A) �ŵ�һ
    // 2. ��ϵB (COMMERCIAL_STREET_B) �ŵڶ�
    // 3. ��������ĸ˳��
    return allRegions.sort((a, b) => {
      if (a === KEYWORDS.COMMERCIAL_STREET_A) return -1
      if (b === KEYWORDS.COMMERCIAL_STREET_A) return 1
      if (a === KEYWORDS.COMMERCIAL_STREET_B) return -1
      if (b === KEYWORDS.COMMERCIAL_STREET_B) return 1
      return a.localeCompare(b, 'zh-CN')
    })
  }, [regionMap])

  // ��ȡ��ǰѡ�������վ��
  const currentStations = useMemo(() => {
    if (!selectedRegion) return []
    return regionMap.get(selectedRegion) || []
  }, [selectedRegion, regionMap])

  const handleRefresh = () => {
    refreshStations(undefined, undefined, { force: true })
  }

  // �򵥵�������ʽ��ȷ��������
  const containerStyle: React.CSSProperties = {
    padding: '20px',
    maxWidth: '600px',
    margin: '0 auto',
    minHeight: '100vh',
    backgroundColor: '#f9fafb',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    color: '#1f2937' // ȷ��ȫ��������ɫҲ����ɫ
  }

  const headerStyle: React.CSSProperties = {
    textAlign: 'center',
    marginBottom: '24px',
    color: '#1f2937'
  }

  const selectStyle: React.CSSProperties = {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    backgroundColor: '#374151', // ���ɫ����
    color: 'white', // ��ɫ����
    marginBottom: '24px',
    outline: 'none'
  }

  const listContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  }

  const cardContentStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '16px'
  }

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>{KEYWORDS.TITLE}</h1>
      
      <div>
        <select 
          style={selectStyle}
          value={selectedRegion}
          onChange={(e) => setSelectedRegion(e.target.value)}
          disabled={isLoading}
        >
          <option value="" disabled style={{ color: '#9ca3af' }}>{KEYWORDS.SELECT_REGION}</option>
          {regions.map((region) => (
            <option key={region} value={region} style={{ color: 'white', backgroundColor: '#374151' }}>
              {region} ({regionMap.get(region)?.length}{KEYWORDS.STATION_COUNT_SUFFIX})
            </option>
          ))}
        </select>
      </div>

      <div style={listContainerStyle}>
        {selectedRegion && currentStations.map((station) => (
          <Card key={station.stationId} style={{ backgroundColor: '#1f2937', border: '1px solid #374151' }}>
            <div style={cardContentStyle}>
              <div>
                <h3 style={{ fontWeight: 600, fontSize: '16px', marginBottom: '4px', color: 'white' }}>
                  {station.stationName.replace(KEYWORDS.PREFIX, '')}
                </h3>
                <p style={{ fontSize: '14px', color: '#9ca3af' }}>{station.address}</p>
              </div>
              <Chip 
                color={station.freeNum && station.freeNum > 0 ? "success" : "default"}
                variant="flat"
              >
                {KEYWORDS.FREE}: {station.freeNum ?? 0}
              </Chip>
            </div>
          </Card>
        ))}

        {selectedRegion && currentStations.length === 0 && (
          <div style={{ textAlign: 'center', color: '#6b7280', padding: '32px 0' }}>
            {KEYWORDS.NO_DATA}
          </div>
        )}

        {!selectedRegion && (
          <div style={{ textAlign: 'center', color: '#6b7280', padding: '48px 0' }}>
            {KEYWORDS.PLEASE_SELECT}
          </div>
        )}
      </div>

      <div style={{ marginTop: '32px', textAlign: 'center' }}>
        <button 
          onClick={handleRefresh}
          style={{ 
            color: '#2563eb', 
            textDecoration: 'underline', 
            background: 'none', 
            border: 'none', 
            cursor: isLoading ? 'not-allowed' : 'pointer',
            opacity: isLoading ? 0.5 : 1
          }}
          disabled={isLoading}
        >
          {isLoading ? KEYWORDS.REFRESHING : KEYWORDS.REFRESH_DATA}
        </button>
      </div>
    </div>
  )
}
